import { GetAiTestConfigEnvironmentTagsRequest } from '@eggplant/api-requests'
import { TagsInput } from '@eggplant/pattern-library'
import type { GetTagsResponse } from '@eggplant/types'

interface Tag {
  id: string
  color: string
  name: string
}

type SelectedCriteriaType = string[]

interface Props {
  onChange: (critera: SelectedCriteriaType) => void
  value: SelectedCriteriaType
  isDisabled?: boolean
  placeholder?: string
}

const getSelectedTags = (items: Tag[], selectedCriteria: SelectedCriteriaType) =>
  items.filter((tag: Tag) =>
    selectedCriteria.includes(tag.id)
  )

const SelectExecutionEnvironmentTag = ({
  onChange,
  value,
  isDisabled = false,
  placeholder = 'Select criteria tags'
}: Props) => {
  const handleChange = (criteria: Tag[]) => {
    onChange(
      criteria.map(({ id }) => id) // strip off the extra properties
    )
  }

  return (
    <GetAiTestConfigEnvironmentTagsRequest>
      {
        (data: GetTagsResponse) =>
          <div>
            <TagsInput
              availableTags={data.items}
              isDisabled={isDisabled}
              isNewItemAllowed={false}
              isRequired
              maxLength={50}
              onSelectedTagsChanged={handleChange}
              placeholder={placeholder}
              selectedTags={getSelectedTags(data.items, value)}
            />
          </div>
      }
    </GetAiTestConfigEnvironmentTagsRequest>
  )
}

export default SelectExecutionEnvironmentTag
